import { h } from 'preact';
import clsx from 'clsx';

const getSizedImageUrl = (src, size) => {
  if (size === null) return src;
  if (!src) return false;
  if (src?.includes('salsify')) {
    const srcArray = src.split('/');
    let newSrc = '';
    srcArray.map((src, index) => {
      newSrc += src;
      if (index === srcArray.length - 2) {
        newSrc += `/w_${size}`;
      }
      if (index !== srcArray.length - 1) {
        newSrc += '/';
      }
      return '';
    });
    return newSrc;
  }
  const match = src.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i,
  );
  if (!match) return null;
  const prefix = src.split(match[0]);
  const suffix = match[0];
  return `${prefix[0]}_${size}x${suffix}`.replace(/http(s)?:/, '');
};

const Image = ({
  alt = '', // if null is passed it won't use the default
  className,
  src,
  srcWidths = {},
  height,
  width,
  loading = 'lazy',
  title,
  style,
}) => {
  const bps = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };

  // Remove undefined breakpoints
  Object.keys(bps).forEach((key) => srcWidths[key] ?? delete bps[key]);

  // Reduce to values arrays
  const srcWidthsReduced = Object.values(srcWidths);
  const sizeWidthsReduced = Object.values(bps);

  // Convert to srcset and sizes values
  const srcsetFormatted = srcWidthsReduced.length
    ? srcWidthsReduced.map((w) => `${getSizedImageUrl(src, w)} ${w}w`).join(',')
    : '';
  const sizesFormatted = srcWidthsReduced.length
    ? `${srcWidthsReduced
        .map((w, i) => `(max-width: ${sizeWidthsReduced[i]}px) ${w}px`)
        .slice(0, srcWidthsReduced.length - 1)
        .join(',')}, ${srcWidthsReduced[srcWidthsReduced.length - 1]}px`
    : '';

  return (
    <img
      className={clsx('image', className)}
      srcset={srcsetFormatted}
      sizes={sizesFormatted}
      src={src}
      alt={alt || ''}
      height={height}
      width={width}
      loading={loading}
      title={title}
      style={style}
    />
  );
};

export default Image;
